import { createContext, useContext } from 'react';

/**
 * How deeply the current graph is nested inside another graph.
 *
 * Graphs are made of StepNodes, and a StepNode may itself render another graph
 * (a sub-action preview). Without a depth signal, an action that calls an action
 * would expand forever — so renderers that embed a graph mark it as nested, and
 * anything that would recurse checks the depth first.
 *
 * Lives outside `WorkflowGraphView` so that file exports only components and
 * Fast Refresh can preserve component state.
 */
export const GraphNestingDepthContext = createContext(0);

export function useGraphNestingDepth(): number {
  return useContext(GraphNestingDepthContext);
}
